import { Tag } from '@playq/octopus-common';

export function mapMetaToTags(meta: { [key: string]: string }): Tag[] {
  return Object.keys(meta).map((key) => new Tag({ key, value: meta[key] }));
}
